import { cva } from 'class-variance-authority';

export const buttonStyles = cva(
  [
    'rounded-md font-medium transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2',
    'px-4 py-2 text-sm',
  ],
  {
    variants: {
      variant: {
        primary:
          'bg-action-button border-action-button active:bg-action-button-hover active:border-action-focus focus:bg-action-focus hover:bg-action-button-hover relative flex items-center justify-center border-[0.125rem] text-white text-white shadow-[0_2px_6px_0_rgba(0,0,0,0.3)] outline-none hover:bg-blue-700 hover:outline-none focus:text-black focus:outline-none active:border-[0.125rem] active:border-solid active:text-white active:outline-none',
        secondary:
          'text-action-button border-action-button hover:bg-action-button hover:shadow-[0_0_0.125rem_0.735rem_rgba(0,0,0,0.3 )] focus:bg-action-focus active:bg-action-button-hover active:shadow-action-focus relative flex items-center justify-center border-[0.125rem] border-[0.125rem] border-solid border-blue-700 bg-transparent hover:border-[0.125rem] hover:border-solid hover:border-transparent hover:bg-blue-700 hover:text-white hover:text-white hover:outline-none focus:border-[0.125rem] focus:border-solid  focus:text-black focus:outline-none active:text-white active:shadow-[0_0_0_0.125rem] active:outline-none',
        outlined:
          'relative flex items-center justify-center border border-gray-300 bg-transparent text-gray-700 hover:border-gray-500',
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  },
);
